export enum SHIPPING_METHOD_TYPE {
    COURIER_LOCAL = 'InPostKurierShippingMethod',
    COURIER = 'InPostKurierShippingMethod',
    PARCEL = 'InPostPaczkomatShippingMethod',
}
